import { UseQueryOptions } from '@ts-rest/react-query/v5';
import { COLLECTION_QUERY_KEY } from './collections.query-keys';
import { type ClientArgs, type ClientInferResponseBody } from '@ts-rest/core';
import { wasticApiContract, WebContractListCollectionsQueryParams } from '@packages/contracts';

export type CollectionRoute = typeof wasticApiContract.web.collections;
export type GetCollectionBySlugRoute = CollectionRoute['getBySlug'];
export type ListCollectionsRoute = CollectionRoute['list'];

export type GetCollectionBySlugResponse = ClientInferResponseBody<GetCollectionBySlugRoute, 200>['data']['collection'];
export type GetCollectionBySlugQueryOptions = UseQueryOptions<
	GetCollectionBySlugRoute,
	ClientArgs,
	GetCollectionBySlugResponse
>;

export function createGetCollectionBySlugQueryOption(collectionSlug: string): GetCollectionBySlugQueryOptions {
	return {
		queryKey:  COLLECTION_QUERY_KEY.GET_BY_SLUG(collectionSlug),
		queryData: { params: { collectionSlug } },
		select:    data => data.body.data.collection,
	};
}

export type ListCollectionsResponse = ClientInferResponseBody<ListCollectionsRoute, 200>['data'];
export type ListCollectionsQueryOptions = UseQueryOptions<
	ListCollectionsRoute,
	ClientArgs,
	ListCollectionsResponse
>;
export function createListCollectionsQueryOption(
	queryParams: WebContractListCollectionsQueryParams,
): ListCollectionsQueryOptions {
	return {
		queryKey:  COLLECTION_QUERY_KEY.LIST(queryParams),
		queryData: { query: queryParams },
		select:    data => data.body.data,
	};
}
